<template>
  <div class="user-selector">
    <div class="users">
      <div v-for="(user, key) in users"
           :key="key"
           @click.stop="toggleUser(user.id)"
           class="avatar"
          :class="{ 'selected' : selectedUsers.indexOf(user.id) > -1 }">
        <client-code v-if="!user.icon"
                     class="avatar-img"
                     :code="user.first_name.substr(0, 1).toUpperCase() + user.last_name.substr(0, 1).toUpperCase()"
                     :seed="user.first_name"
                     :title="user.first_name + ' ' + user.last_name"/>
        <img v-if="user.icon" :src="user.icon_url" class="avatar-img" :title="user.first_name"/>
        <p class="name">{{ user.first_name }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'user-selector',
    components: {},
    props: ['value'],
    data () {
      return {
        selectedUsers: []
      }
    },
    methods: {
      toggleUser (id) {
        // User already added.. remove them
        let index = this.selectedUsers.indexOf(id)
        if (index > -1) {
          this.selectedUsers.splice(index, 1)
        } else {
          // User not added
          this.selectedUsers.push(id)
        }
        this.$emit('input', this.selectedUsers)
      }
    },
    computed: {
      // Vuex Mappings
      users () {
        return this.$store.getters.activeUsers.slice().sort((a, b) => {
          if (a.first_name < b.first_name) return -1
          if (a.first_name > b.first_name) return 1
          return 0
        })
      }
    },
    mounted () {
      this.selectedUsers = this.value
    }
  }
</script>

<style lang="less" rel="stylesheet/less">
  .user-selector {
    text-align: left;
    .users {
      display: inline-block;
      vertical-align: middle;
    }

    .avatar {
      display: inline-block;
      vertical-align: middle;
      text-align: center;

      margin: 0 5px 5px;
      cursor: pointer;

      .avatar-img {
        width: 40px;
        height: 40px;
        border-radius: 20px;
        box-shadow: 1px 1px 2px #606266;
        border: 2px solid transparent;
        margin: 0;
        transition: all 0.3s;
        display: block;
        overflow: hidden;

        &.client-code {
          font-size: 14px;
          line-height: 40px;
        }
      }
      .name {
        margin: 5px 0;
        font-size: 10px;
        transition: color 0.3s;
        line-height: 1.3em;
      }

      &:hover {
        .name {
          color: #333;
        }
      }
      &.selected {
        .avatar-img {
          border: 2px solid #409EFF;
        }
        .name {
          color: #409EFF;
        }
      }
    }

  }

</style>
